import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { changeDateFormat } from '@utils/Util';

const CollectionViewItemsCostingItems = () => {
	const navigate = useNavigate();
	const listOfCosting = useSelector((store) => store.filterResponseStore);

	const renderDesign = () => {
		return listOfCosting?.data?.map((item) => {
			return (
				<div
					onClick={() => {
						navigate(`/collections/view/${item?.id}?requestFrom=costing`);
						// dispatch(clearCosting());
					}}
					className="single-collection-item"
					key={`costing_item_${item.id}`}
				>
					<div className="product-img-container">
						<div className="prev-img">
							{item?.documentPathList && item?.documentPathList[0] ? (
								<img src={item?.documentPathList[0]} alt="" />
							) : (
								<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
							)}
						</div>
						<div className="prev-img-thumb">
							<div className="single-first">
								{item?.documentPathList && item?.documentPathList[1] ? (
									<img src={item?.documentPathList[1]} alt="" />
								) : (
									<img
										src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
										alt=""
									/>
								)}
							</div>
							<div className="single-second">
								{item?.documentPathList && item?.documentPathList[2] ? (
									<img src={item?.documentPathList[2]} alt="" />
								) : (
									<img
										src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
										alt=""
									/>
								)}
							</div>
						</div>
					</div>
					<div className="design-details d-flex justify-content-between">
						<div className="photoshoot-status">
							<p className="regular-14 gray_dark_02">
								<span className="green">{item?.completedPhotography}</span>/
								{parseInt(item?.pendingPhotography) + parseInt(item?.completedPhotography)}
							</p>
						</div>
						<div className="design-details d-flex justify-content-between">
							<div className="details">
								<p className="collection-title regular-12 mb-0 gray_dark_01 weight-500">
									{item?.title || item?.collectionName}
								</p>
								<ul className="common-list-component mt-1">
									<li>
										<span className="name gray_dark_02">{item?.ownerName}</span>
									</li>
									<li>
										<span className="weight-300 gray_dark_01">{item?.brand}</span>
									</li>
									<li>
										<p className="gray_dark_02">
											<span className="weight-300">RQD</span>
											<span className="gray_dark_01 ml-2">
												{changeDateFormat(item?.dateCreated, 'YYYY-MM-DD', 'DD MMM')}
											</span>
										</p>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			);
		});
	};

	return (
		<div className="designs-collections-container pl-2 bg-white">
			<div className="collections-row"> {renderDesign()} </div>
		</div>
	);
};

export default CollectionViewItemsCostingItems;
